import AddRequestTravel from '@/requests/travels/user/addRequestTravel';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/$id/travels/addTravel',
)({
  
  component: AddRequestTravel,
});
